import { createContext } from "react";
import { useImmerReducer } from "use-immer";

// return a number of anonymous contexts in an array
export default function makeContexts(num) {
    const contexts = [];
    for (let i=1;i<=num;i++) {
        contexts.push(createContext());
    }
    return contexts;
}


// returns an anonymous provider for a particular context and dispatch
export function makeProvider(Context, DispatchContext, reducer, init) {
    return ({ children }) => {
        const [store, dispatch] = useImmerReducer(reducer, init);
  
        return (
        <Context.Provider value={store}>
            <DispatchContext.Provider value={dispatch}>
            {children}
            </DispatchContext.Provider>
        </Context.Provider>
        );
    }
}

export function normalize(arr, key = 'id') {
    let obj = {};
    if (arr) {
        arr.forEach(e => {
            obj[e[key]] = {...e};
        });
    }
    return obj;
}